module.exports = __webpack_public_path__ + "img/a1.854d6519.png";